import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Navigation, Router, RouterOutlet } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CommonChartmoduleService } from '../Services/common-chartmodule.service';
import { SnapshotService } from '../Services/snapshot.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import { forEach } from 'lodash';

@Component({
  selector: 'app-chart-output',
  templateUrl: './chart-output.component.html',
  styleUrls: ['./chart-output.component.scss'],
})
export class ChartOutputComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private routerObj: Router,
    private sanitizer: DomSanitizer,
    private commonChartModule: CommonChartmoduleService,
    private _configService: SnapshotService,
    private _loaderService: LoaderService,
    private clientDetails: SnapshotSharedVariablesService,
    private _configCustomService: CustomsnapshotService,
    private _cdref: ChangeDetectorRef
  ) {
    // this.currentUrl = this.router.url;
  }

  // items: any = [{
  //   customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [

  //     { value: 'disable', label: 'Off', selected: false },
  //     { value: 'enable', label: 'On', selected: true },

  //   ],
  //   className: "",
  //   id: 'Data Label : '
  // },
  // {
  //   "customization": 'Color :', "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
  //   className: 'DataLabelGrouping',
  //   id: 'Data Label Color :',
  // },
  // {
  //   customization: 'Property : ',
  //   func: 'oncheckboxchecked',
  //   inputType: 'dropdown',
  //   options: [
  //     { value: 'default', label: 'Default' },
  //     { value: 'changeversus', label: 'Change Versus' },
  //     { value: 'changeversus+significance', label: 'Change Versus + Significance' },
  //     { value: 'significance', label: 'Significance' },
  //     { value: 'significance2', label: 'Significance Level2' },
  //     { value: 'ls', label: 'Low Sample' },
  //   ],
  //   className: 'DataLabelGrouping',
  //   id: 'Data Label Property : ',
  // },
  // ]
  @ViewChild(RouterOutlet, { static: false }) outlet!: RouterOutlet;
  items: any;
  loadedComponent: any;
  userselectedchartdata: any;
  chartTitle: any;
  showExpandPopup = false;
  showDataLabel: boolean = true;
  legendpattern = /Legend../;
  datalabelpattern = /DataLabel../;
  FirstColumnpattern = /FirstColumn../;
  FirstRowpattern = /FirstRow../;
  islegend: boolean = false;
  isdatalabel: boolean = false;
  isFirstColumn:boolean = false;
  isFirstRow:boolean = true;
  widgetTitleText: string = 'Trend Of Metric 2';
  iscustomWidgetIcon: boolean = false;
  customWidgetIcontext: string = '';
  bucketName: string = "";
  showErrorPopUp: boolean = false;
  popUpMessage: string = "";
  errorheaderTitle: string = "";
  selectedValue: any;
  isRefresh: boolean = true;  // Initial value



  chartImagesPreviewList: any = {
    'Vertical Bar Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Bar.png',
    "Vertical Cluster Bar Chart": '',
    "Horizontal Bar Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Bar.png',
    "Horizontal Cluster Bar Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Clustered Bar.png',
    "AREA CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Area Chart.png',
    "LINE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Line chart.png',
    "Vertical Lollipop Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Vertical lollipop Chart.png',
    "Horizontal Lollipop Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal lollipop.png',
    "Cluster Lollipop Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Cluster lollipop.png',
    "01/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 01.png',
    "02/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 02.png',
    "03/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 03.png',
    "04/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 04.png',
    "05/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 05.png',
    "06/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 06.png',
    "07/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 07.png',
    "08/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 08.png',
    "09/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 09.png',
    "10/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 10.png',
    'Scatter Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Scatter Chart.png',
    'Quadrant Scatter Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Quadrant Scatter Chart.png',
    'Bubble Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Bubble Chart.png',
    'Quadrant Bubble Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Quadrant Bubble Chart.png',
    "Vertical Stacked Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Vertical Stacked.png',
    "Horizontal Stacked Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Stacked.png',
    "01/FUNNEL CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Funnel Chart.png'
  }


  widgetList = [
    {
      widgetName: "Trend of Metric 2",
      visualization: "Trend Chart",
      image: "",
      active: false
    },
    {
      widgetName: "Brand Power Grid",
      visualization: "Bubble Chart",
      image: "https://upload.wikimedia.org/wikipedia/en/a/af/Star_Wars_The_Rise_of_Skywalker_poster.jpg",
      active: false
    },
    {
      widgetName: "Unaided awareness",
      visualization: "01/Pie Chart",
      image: "",
      active: false
    },
    {
      widgetName: "Imagery Statements",
      visualization: "Horizontal Bar",
      image: "",
      active: false
    }

  ]

  chartproperties: any;
  isEditWidget: boolean = false;
  countOfMetricsTobeConfigured: number = 0;
  maxMetricLimit:number=0;
  ngAfterViewInit() {
    const isParentChild = sessionStorage.getItem('isFromParent');
    const savedValue = sessionStorage.getItem('isRefresh');
    const navEntries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
    if (isParentChild == "true") {
      sessionStorage.setItem('isFromParent', 'false');
      sessionStorage.setItem('isRefresh', 'true');
      const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: true };
      sessionStorage.setItem('dataToSend', JSON.stringify(dataToSend));
      sessionStorage.setItem('selectedSnapshotType', JSON.stringify(this._configCustomService.selectedSnapshotType));
      sessionStorage.setItem('selectedSection', this._configCustomService.selectedSection);
      sessionStorage.setItem('selectedSubsection', this._configCustomService.selectedSubsection);
      this.route.paramMap.subscribe((params) => {
        const userData = history.state.userData;
        this.userselectedchartdata = userData; // Use the userData object as needed
        this.chartTitle = this.userselectedchartdata?.selectedChartTitle;
        this.bucketName = this.userselectedchartdata?.routePath.split("/")[0];
      });
      if (this.outlet) {
        this.loadedComponent = this.outlet.component;
      }
      if (this.loadedComponent) {
        // this.items = 
        this.loadedComponent.customization().subscribe((data: any) => {
          // Use the data as needed\\
          data = data.map((item: any) => {
            // Add the selectedValue property
            return {
              ...item,
              selectedValue: '' // or initialize with a default value
            };
          });
          data.forEach((i:any) => {
            if (i.customization === 'Quadrant Color Code : ') {
              i.value = '#808080';
            }
            if(i.customization=='Calculation Logic : '){
              i.selectedValue=i.options.find((l:any)=>l.isSelected).label;
            }
          });

          this.items = data;
          this.countOfMetricsTobeConfigured = this.items.filter((i: any) => i.customization?.replace(/\s/g, '')?.toLowerCase()?.includes("metric")).length;
          this.maxMetricLimit=this.items.filter((i: any) => i.customization?.replace(/\s/g, '')?.toLowerCase()?.includes("metric"))[0]?.maxMetricLimit;
          let widgetname = this.items.find((i: any) => i.customization?.includes("Widget Name"));
          if (!widgetname) {
            this.widgetTitleText = "Trend Chart";
          }
          this.items.forEach((i: any) => {
            if (i.id == "Metric" && this.chartTitle.toLowerCase()=="funnel chart") {
              i.maxMetricLimit = this.numberofFunnelLevels;
            }
            if (i.id == "Metric" && this.chartTitle.toLowerCase()=="table") {
              i.maxMetricLimit = 10000;
            }
          })
          if (this.userselectedchartdata.widgetEditSelection) {
            if (this.userselectedchartdata.widgetEditSelection?.customizationProperties != "") {
              this.chartproperties = JSON.parse(this.userselectedchartdata.widgetEditSelection?.customizationProperties);
              let metricdata = this.userselectedchartdata.widgetEditSelection?.metric;
              this.metric = metricdata;
              this.isEditWidget = true;
              this.bindCustomization(this.items);
            }
          }
          else {
            let a = this.items.find((x: any) => x.customization == "Number of Levels : ");
            if (a) {
              a.selectedValue = "4";
            }
            let b = this.items.find((x: any) => x.customization == "First Column as header : ");
            if(b){
              b.checked=true;
            }
            let b1 = this.items.find((x: any) => x.customization == "Column Header Sorting : ");
            if(b1){
              b1.checked=true;
              this.checkbox[b1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = true;
            }
            let b2 = this.items.find((x: any) => x.customization == "Hide NA : ");
            if(b2){
              b2.checked=true;
              this.checkbox[b2.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = true;
            }
            let b3 = this.items.find((x: any) => x.customization == "Freeze First Column : ");
            if(b3){
              b3.checked=true;
              this.checkbox[b3.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = true;
            }
            let b4 = this.items.find((x: any) => x.customization == "Freeze First Row  : ");
            if(b4){
              b4.checked=true;
              this.checkbox[b4.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = true;
            }
          }
        });
      }
    }
    else if (savedValue == "true") {
      if (navEntries && navEntries.length > 0 && navEntries[0].type === 'reload') {
        sessionStorage.setItem('isRefresh', 'false');
        //this.router.navigate(['/Snapshot/configuaration']);
        this._configService.fromBackButton = false;
        this._configCustomService.fromBackButton = false;
        const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: false };
        let refreshData = JSON.parse(sessionStorage.getItem('dataToSend') || "{}");
        // this._configCustomService.selectedSnapshotType=JSON.parse(sessionStorage.getItem('selectedSnapshotType') || "{}");
        // this._configCustomService.selectedSection=sessionStorage.getItem('selectedSection');
        // this._configCustomService.selectedSubsection=sessionStorage.getItem('selectedSubsection');
        this._configCustomService.recievedStatusDataOnBackButtonClick = refreshData;
        this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = false;
        this._configService.ifDataExists = true;
        this.clientDetails.clientDetails = refreshData.clientDetails.clientDetails;
        this.routerObj.navigate(['/Snapshot/configuaration'], { state: { data: refreshData } });
      }
      else {
      }
    }

  }
  showExpandPopupFun() {

    //this.infoTextTitle = this.widgetName;

    this.showExpandPopup = true;
  }
  hide(data: any) {
    this.showExpandPopup = data;
  }
  getSelectedValue1(item: any) {
    let selectedvalue = item.selectedValue != "" ? item.selectedValue : item.options[0].label;
    return selectedvalue;
  }
  onModelChange(selectedValue: string, item: any) {
    // You can add your custom logic here
    item.selectedValue = selectedValue !== '' ? selectedValue : item.options[0].label;
  }
  bindCustomization(data: any) {
    data.forEach((item1: any) => {
      switch (item1.id) {
        // case "Quadrant Color Code":{
        //   item1.value = this.chartproperties?.dashStyle === "none" ? "#808080" : "#000000"; ;
        //   break;
        // }
        case "Widget Name":
          {
            this.widgetTitleText = this.userselectedchartdata?.widgetEditSelection?.widget_name;
            break;
          }
        case "Info Button":
          {
            this.customWidgetIcontext = this.chartproperties?.infoText;
            break;
          }
        case "Start Value":
          {
            item1.value = this.chartproperties?.startvalue;
            break;
          }
        case "End Value":
          {
            item1.value = this.chartproperties?.endvalue;
            break;
          }
        case "Target Value":
          {
            item1.value = this.chartproperties?.Targetvalue;
            break;
          }
        case "Legend":
          {
            if (this.chartproperties?.showLegend) {
              item1.options.forEach((i: any) => {
                if (i.value == "enable") {
                  i.selected = true
                  this.islegend = false;
                }
                else {
                  i.selected = false
                }
              })
            }
            else {
              item1.options.forEach((i: any) => {
                if (i.value == "disable") {
                  i.selected = true
                  this.islegend = true;
                }
                else {
                  i.selected = false
                }
              })
            }
            break;
          }
        case 'Legend position':
          {
            item1.options.forEach((i: any) => { i.selected = false });
            let option = item1.options.find((m: any) => m.value == this.chartproperties?.legendPosition);
            if (option) {
              option.selected = true;
            };
            break;
          }
        case "Data Label": {
          if (this.chartproperties?.showDataLabel) {
            item1.options.forEach((i: any) => {
              if (i.value == "enable") {
                i.selected = true;
                this.isdatalabel = false;
                this.showDataLabel = true;
              }
              else {
                i.selected = false;
              }
            })
          }
          else {
            item1.options.forEach((i: any) => {
              if (i.value == "disable") {
                i.selected = true;
                this.isdatalabel = true;
                this.showDataLabel = false;
              }
              else {
                i.selected = false;
              }
            })
          }
          break;
        }
        case "Data Label Colour":
          {
            item1.value = this.chartproperties?.dataLabelColor == "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Banded Row":
          {
            item1.value = this.chartproperties?.BannedRow == "" ? "#ffffff" : this.chartproperties?.BannedRow;
            break;
          }
        case "Banded Column":
          {
            item1.value = this.chartproperties?.BannedColumn == "" ? "#ffffff" : this.chartproperties?.BannedColumn;
            break;
          }
        case "Border Colour":
          {
            item1.value = this.chartproperties?.borderColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Column Header Font  Colour":
          {
            item1.value = this.chartproperties?.ColumnHeaderFontColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Row Header Font Colour":
          {
            item1.value = this.chartproperties?.RowHeaderFontColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Column Header Cell  Colour":
          {
            item1.value = this.chartproperties?.ColumnHeaderCellColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Row Header Cell  Colour":
          {
            item1.value = this.chartproperties?.RowHeaderCellColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Gridlines colour ":
          {
            item1.value = this.chartproperties?.gridlinecolor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Data Label Property":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.datalabelStyle)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Data Label Size":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.dataLabelSize)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Decimal Round off":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.decimalRoundOff)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Marker Style":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.markerStyle)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Line Style ":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.Linestyle)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Gridlines dash ":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.gridlinestyle)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Column Header Font Size":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.ColumnHeaderFontSize)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Row Header Font Size":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.RowHeaderFontSize)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Column Header Alignment":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.ColumnHeaderAlignment)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Row Header Alignment":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.RowHeaderAlignment)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Data Label Alignment":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.RowHeaderAlignment)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Border Thickness":
          {
            if(this.chartproperties?.borderStyle == "2"){
              item1.selectedValue ="All borders";
            }
            else if(this.chartproperties?.borderStyle == "1"){
              item1.selectedValue ='Outside Border';
            }
            else{
              item1.selectedValue ='No borders';
            }
            this._cdref.detectChanges();
            break;
          }
        case "First Column as header":
          {
            item1.checked = (this.chartproperties?.FirstColumn) ? (this.chartproperties?.FirstColumn) : false;
            this.isFirstColumn = (this.chartproperties?.FirstColumn) ? (!this.chartproperties?.FirstColumn) : true;
            //this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "First Row as header":
          {
            item1.checked = (this.chartproperties?.FirstRow) ? (this.chartproperties?.FirstRow) : false;
            this.isFirstRow = (this.chartproperties?.FirstRow) ? (!this.chartproperties?.FirstRow) : true;
            //this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
      //  case "Trendline in Exports ":
      //     {
      //       item1.checked = (this.chartproperties?.TrendlineinExports) ? (this.chartproperties?.TrendlineinExports) : false;
      //       break;
      //     }
        case "Trendline":
          {
            item1.selectedValue = (this.chartproperties?.Trendline) ? (this.chartproperties?.Trendline) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Column Header Sorting":
          {
            item1.selectedValue = (this.chartproperties?.ColumnHeaderSorting) ? (this.chartproperties?.ColumnHeaderSorting) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Hide NA":
          {
            item1.selectedValue = (this.chartproperties?.HideNA) ? (this.chartproperties?.HideNA) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Highlight Column Total ":
          {
            item1.selectedValue = (this.chartproperties?.HighlightColumnTotal) ? (this.chartproperties?.HighlightColumnTotal) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Highlight  Row Total ":
          {
            item1.selectedValue = (this.chartproperties?.HighlightRowTotal) ? (this.chartproperties?.HighlightRowTotal) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Transpose ":
          {
            item1.selectedValue = (this.chartproperties?.Transpose) ? (this.chartproperties?.Transpose) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Data Label Overlap ":
          {
            item1.selectedValue = (this.chartproperties?.DataLabelOverlap ) ? (this.chartproperties?.DataLabelOverlap) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Axes":
          {
            item1.selectedValue = (this.chartproperties?.Axes) ? (this.chartproperties?.Axes) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Sector fill":
          {
            item1.selectedValue = (this.chartproperties?.Sectorfill) ? (this.chartproperties?.Sectorfill) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Trendline in Exports ":
          {
            item1.selectedValue = (this.chartproperties?.TrendlineinExports) ? (this.chartproperties?.TrendlineinExports) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Freeze First Column":
          {
            item1.selectedValue = (this.chartproperties?.FreezeFirstColumn) ? (this.chartproperties?.FreezeFirstColumn) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Freeze First Row ":
          {
            item1.selectedValue = (this.chartproperties?.FreezeFirstRow) ? (this.chartproperties?.FreezeFirstRow) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Trend Area":
          {
            item1.selectedValue = (this.chartproperties?.TrendArea) ? (this.chartproperties?.TrendArea) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;

            break;
          }
        case "Selected/ All brands":
          {
            item1.selectedValue = (this.chartproperties?.SelectedAllbrands) ? (this.chartproperties?.SelectedAllbrands) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Image Fill":
          {
            item1.selectedValue = (this.chartproperties?.ImageFill) ? (this.chartproperties?.ImageFill) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Sorting":
          {
            item1.selectedValue = (this.chartproperties?.Sorting) ? (this.chartproperties?.Sorting) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Top 10":
          {
            item1.selectedValue = (this.chartproperties?.Top10) ? (this.chartproperties?.Top10) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "100% Stack chart":
          {
            item1.selectedValue = (this.chartproperties["100Stackchart"]) ? (this.chartproperties["100Stackchart"]) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Stack position":
          {
            item1.selectedValue = (this.chartproperties?.Stackposition) ? (this.chartproperties?.Stackposition) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Axis Image":
          {
            item1.selectedValue = (this.chartproperties?.AxisImage) ? (this.chartproperties?.AxisImage) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Line Style":
          {
            item1.selectedValue = (this.chartproperties?.LineStyle) ? (this.chartproperties?.LineStyle) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "X Axis Gridlines":
          {
            item1.selectedValue = (this.chartproperties?.XAxisGridlines) ? (this.chartproperties?.XAxisGridlines) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Y Axis Gridlines":
          {
            item1.selectedValue = (this.chartproperties?.YAxisGridlines) ? (this.chartproperties?.YAxisGridlines) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Data Label Overlap":
          {
            item1.selectedValue = (this.chartproperties?.DataLabelOverlap) ? (this.chartproperties?.DataLabelOverlap) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Enable data bars(within cells)":
          {
            item1.checked = (this.chartproperties?.enableDataBars) ? (this.chartproperties?.enableDataBars) : false;
            break;
          }
        case "Calculation Logic":
          {
            item1.selectedValue=this.chartproperties?.CalculationLogic;
            item1.options.forEach((l2:any)=>{
              if(l2.value==this.chartproperties?.CalculationLogic){
                l2.isSelected=true;
              }
              else{
                l2.isSelected=false;
              }
              if(l2.value=="None"){
                l2.color=this.chartproperties?.calculationNoneColor;
              }
              if(l2.value=="BIPS"){
                l2.options.forEach((l22:any)=>{
                  if(l22.value=='negativeRange'){
                    l22.inputvalue=this.chartproperties?.bipsNegativeRange;
                    l22.color=this.chartproperties?.bipsNegativeRangeColor;
                  }
                  if(l22.value=='positiveRange'){
                    l22.inputvalue=this.chartproperties?.bipsPositiveRange;
                    l22.color=this.chartproperties?.bipsPositiveRangeColor;
                  }
                })
              }
            })
            
            break;
          }
        case "X Axis Label Orientation":
          {
            item1.options.forEach((i: any) => i.selected = false);
            item1.options.forEach((i: any) => {
              if (i.value == this.chartproperties?.axisLabelOrientation) {
                i.selected = true;
              }
            });
            break;
          }
        case "Y Axis Label Orientation":
          {
            item1.options.forEach((i: any) => i.selected = false);
            item1.options.forEach((i: any) => {
              if (i.value == this.chartproperties?.yaxisLabelOrientation) {
                i.selected = true;
              }
            });
            break;
          }
        case "Metric": {
          let metricdata = this.userselectedchartdata.widgetEditSelection?.metric.find((m: any) => m.metric_option.replace(" : ", "") == "Metric");

          if (metricdata) {
            if (metricdata.metric_value.length != 0) {
              metricdata.metric_value = JSON.parse(metricdata.metric_value[0]);
            }
            if (item1.select != 3) {
              // metricdata.metric_value.forEach((mm: any) => {
              //   let it = item1.options.find((i: any) => i.option == mm.option);
              //   if (it) {
              //     it.isSelected = true;
              //     it.selectOrder = mm.selectOrder;
              //     it.checked = true;
              //     item1.checkedList.push(mm);
              //   }
              // })
              metricdata.metric_value.forEach((mm: any) => {
                //let it = item1.options.find((i: any) => i.option == mm.option);
                if(mm.typeofmetric!=undefined && mm.typeofmetric!=null){
                  let it = item1.options.find((i: any) => i.option == mm.typeofmetric);
                  if(it){
                    it.Level2.forEach((lev2:any) => {
                      if(lev2.option == mm.option){
                        lev2.isSelected = true;
                        lev2.selectOrder = mm.selectOrder;
                        if(item1.select == 1){
                          lev2.checked = true;
                        }else{
                          lev2.isSelected = true;
                        }
                        item1.checkedList.push(mm);
                      }
                    })
                  }
                }
              })
            }
            else {
              if (metricdata.metric_group == "") {
                let it = item1.options.find((i: any) => i.option == "METRICS");
                if (it) {
                  metricdata.metric_value.forEach((mm: any) => {
                    it.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }

                let customMetrics = item1.options.find((i: any) => i.option == "CUSTOM METRICS");
                if (customMetrics) {
                  metricdata.metric_value.forEach((mm: any) => {
                    customMetrics.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }
              }
              else {
                let it = item1.options.find((i: any) => i.option == "METRIC GROUP");
                if (it) {
                  it.Level2.forEach((il2: any) => {
                    if (il2.option == metricdata.metric_group) {
                      il2.isSelected = true;
                      il2.checked = true;
                      item1.checkedList.push({ option: metricdata.metric_group, selectOrder: 0 });
                    }
                  })

                }
              }
            }
          }
          break;
        }
        case "XAxis Metric": {
          let metricdata = this.userselectedchartdata.widgetEditSelection?.metric.find((m: any) => m.metric_option.replace(" : ", "") == "XAxis Metric");
          if (metricdata) {
            if (metricdata.metric_value.length != 0) {
              metricdata.metric_value = JSON.parse(metricdata.metric_value[0]);
            }
            if (item1.select != 3) {
              // metricdata.metric_value.forEach((mm: any) => {
              //   let it = item1.options.find((i: any) => i.option == mm.option);
              //   if (it) {
              //     it.isSelected = true;
              //     it.selectOrder = mm.selectOrder;
              //     it.checked = true;
              //     item1.checkedList.push(mm);
              //   }
              // })

              metricdata.metric_value.forEach((mm: any) => {
                //let it = item1.options.find((i: any) => i.option == mm.option);
                if(mm.typeofmetric!=undefined && mm.typeofmetric!=null){
                  let it = item1.options.find((i: any) => i.option == mm.typeofmetric);
                  if(it){
                    it.Level2.forEach((lev2:any) => {
                      if(lev2.option == mm.option){
                        lev2.isSelected = true;
                        lev2.selectOrder = mm.selectOrder;
                        if(item1.select == 1){
                          lev2.checked = true;
                        }else{
                          lev2.isSelected = true;
                        }
                        item1.checkedList.push(mm);
                      }
                    })
                  }
                }
              })
            }
            else {
              if (metricdata.metric_group == "") {
                let it = item1.options.find((i: any) => i.option == "METRICS");
                if (it) {
                  metricdata.metric_value.forEach((mm: any) => {
                    it.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }

                let customMetrics = item1.options.find((i: any) => i.option == "CUSTOM METRICS");
                if (customMetrics) {
                  metricdata.metric_value.forEach((mm: any) => {
                    customMetrics.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }
              }
              else {
                let it = item1.options.find((i: any) => i.option == "METRIC GROUP");
                if (it) {
                  it.Level2.forEach((il2: any) => {
                    if (il2.option == metricdata.metric_group) {
                      il2.isSelected = true;
                      il2.checked = true;
                      item1.checkedList.push({ option: metricdata.metric_group, selectOrder: 0 });
                    }
                  })

                }
              }
            }
          }
          break;
        }
        case "YAxis Metric": {
          let metricdata = this.userselectedchartdata.widgetEditSelection?.metric.find((m: any) => m.metric_option.replace(" : ", "") == "YAxis Metric");

          if (metricdata) {
            if (metricdata.metric_value.length != 0) {
              metricdata.metric_value = JSON.parse(metricdata.metric_value[0]);
            }
            if (item1.select != 3) {
              // metricdata.metric_value.forEach((mm: any) => {
              //   let it = item1.options.find((i: any) => i.option == mm.option);
              //   if (it) {
              //     it.isSelected = true;
              //     it.selectOrder = mm.selectOrder;
              //     it.checked = true;
              //     item1.checkedList.push(mm);
              //   }
              // })

              metricdata.metric_value.forEach((mm: any) => {
                //let it = item1.options.find((i: any) => i.option == mm.option);
                if(mm.typeofmetric!=undefined && mm.typeofmetric!=null){
                  let it = item1.options.find((i: any) => i.option == mm.typeofmetric);
                  if(it){
                    it.Level2.forEach((lev2:any) => {
                      if(lev2.option == mm.option){
                        lev2.isSelected = true;
                        lev2.selectOrder = mm.selectOrder;
                        if(item1.select == 1){
                          lev2.checked = true;
                        }else{
                          lev2.isSelected = true;
                        }
                        item1.checkedList.push(mm);
                      }
                    })
                  }
                }
              })
            }
            else {
              if (metricdata.metric_group == "") {
                let it = item1.options.find((i: any) => i.option == "METRICS");
                if (it) {
                  metricdata.metric_value.forEach((mm: any) => {
                    it.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }

                let customMetrics = item1.options.find((i: any) => i.option == "CUSTOM METRICS");
                if (customMetrics) {
                  metricdata.metric_value.forEach((mm: any) => {
                    customMetrics.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }
              }
              else {
                let it = item1.options.find((i: any) => i.option == "METRIC GROUP");
                if (it) {
                  it.Level2.forEach((il2: any) => {
                    if (il2.option == metricdata.metric_group) {
                      il2.isSelected = true;
                      il2.checked = true;
                      item1.checkedList.push({ option: metricdata.metric_group, selectOrder: 0 });
                    }
                  })

                }
              }
            }
          }
          break;
        }
        case "ZAxis Metric": {
          let metricdata = this.userselectedchartdata.widgetEditSelection?.metric.find((m: any) => m.metric_option.replace(" : ", "") == "ZAxis Metric");

          if (metricdata) {
            if (metricdata.metric_value.length != 0) {
              metricdata.metric_value = JSON.parse(metricdata.metric_value[0]);
            }
            if (item1.select != 3) {
              // metricdata.metric_value.forEach((mm: any) => {
              //   let it = item1.options.find((i: any) => i.option == mm.option);
              //   if (it) {
              //     it.isSelected = true;
              //     it.selectOrder = mm.selectOrder;
              //     it.checked = true;
              //     item1.checkedList.push(mm);
              //   }
              // })

              metricdata.metric_value.forEach((mm: any) => {
                //let it = item1.options.find((i: any) => i.option == mm.option);
                if(mm.typeofmetric!=undefined && mm.typeofmetric!=null){
                  let it = item1.options.find((i: any) => i.option == mm.typeofmetric);
                  if(it){
                    it.Level2.forEach((lev2:any) => {
                      if(lev2.option == mm.option){
                        lev2.isSelected = true;
                        lev2.selectOrder = mm.selectOrder;
                        if(item1.select == 1){
                          lev2.checked = true;
                        }else{
                          lev2.isSelected = true;
                        }
                        item1.checkedList.push(mm);
                      }
                    })
                  }
                }
              })
            }
            else {
              if (metricdata.metric_group == "") {
                let it = item1.options.find((i: any) => i.option == "METRICS");
                if (it) {
                  metricdata.metric_value.forEach((mm: any) => {
                    it.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }

                let customMetrics = item1.options.find((i: any) => i.option == "CUSTOM METRICS");
                if (customMetrics) {
                  metricdata.metric_value.forEach((mm: any) => {
                    customMetrics.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }
              }
              else {
                let it = item1.options.find((i: any) => i.option == "METRIC GROUP");
                if (it) {
                  it.Level2.forEach((il2: any) => {
                    if (il2.option == metricdata.metric_group) {
                      il2.isSelected = true;
                      il2.checked = true;
                      item1.checkedList.push({ option: metricdata.metric_group, selectOrder: 0 });
                    }
                  })

                }
              }
            }
          }
          break;
        }
        case "Number of Levels": {
          let a = this.items.find((x: any) => x.customization == "Number of Levels : ");
          let metricdata = this.items.find((x: any) => x.id.toLowerCase() == "metric")
          if (a) {
            a.selectedValue = this.chartproperties?.numberOfFunnelLevels;
            if( this.chartTitle.toLowerCase()=="funnel chart"){
              metricdata.maxMetricLimit=a.selectedValue;
            }  
          }
        }
      }
    })
    // this.items = data;

  }
  onSelectedValueChange(newValue: any, item: any) {
    item.selectedValue = newValue;
  }

  customWidgetIcon(event: any, id: any) {
    if (event.target.value === 'custom' && id == 'Info Button') {
      this.iscustomWidgetIcon = true;
    } else {
      this.iscustomWidgetIcon = false;
    }
  }

  bipsColorChange(event:any,lev2:any,item:any){
    this.loadedComponent[item.func](event,lev2.id+'color');
    lev2.color=event.target.value;
    console.log(item);
  }

  qudarentcolorset(event: any, item: any){
    const colorInput = document.getElementById("Quadrant Color Code : ") as HTMLInputElement;
    if(item.id=="Quadrant Dash Style "){
      if(event.target.value != 'none'){
        colorInput.value = "#000000";
      }else{
        colorInput.value = "#808080";
      }
    }

  }




  cutomDropdownClick(item:any,lev1:any,$event:any){
    item.options.forEach((i:any)=>{
      if(i.value==lev1.value){
        i.isSelected=true;
        $event.target.value=i.value;
        item.selectedValue=i.value;
      }
      else{
        i.isSelected=false;
      }
    })
    this.loadedComponent[item.func]($event,item.id);
  }





  updateitems(checkboxchecked: any, event: any) {
    if (checkboxchecked == 'DataLabel') {
      var clickedDiv = event.currentTarget as HTMLDivElement;
      var value = clickedDiv.getAttribute('value');
      if (value == 'disable') {
        this.isdatalabel = true;
      } else {
        this.isdatalabel = false;
      }
    }
    if (checkboxchecked == 'Legend') {
      var clickedDiv = event.currentTarget as HTMLDivElement;
      var value = clickedDiv.getAttribute('value');
      if (value == 'disable' || value == 'disabled') {
        this.islegend = true;
      } else {
        this.islegend = false;
      }
    }
    if (checkboxchecked == 'FirstColumn') {
      // var clickedDiv = event.currentTarget as HTMLDivElement;
      // var value = clickedDiv.getAttribute('value');
      if (event.target.checked == true) {
        this.isFirstColumn = false;
       // this.chartproperties.FirstColumn = true;
      } else {
        this.isFirstColumn = true;
       // this.chartproperties.FirstColumn = false;
      }
    //  localStorage.setItem("properties", JSON.stringify(this.chartproperties));
    }
    if (checkboxchecked == 'FirstRow') {
      // var clickedDiv = event.currentTarget as HTMLDivElement;
      // var value = clickedDiv.getAttribute('value');
      if (event.target.checked == true) {
        this.isFirstRow = false;
        //this.chartproperties.FirstRow = true;
      } else {
        this.isFirstRow = true;
        //this.chartproperties.FirstRow = false;
      }
      //localStorage.setItem("properties", JSON.stringify(this.chartproperties));
    }
  }

  shouldDisableImage(item: any, img: any): boolean {
    if (this.datalabelpattern.test(item.className)) {
      return this.isdatalabel ? true : false;
    }
    if (this.legendpattern.test(item.className)) {
      return this.islegend ? true : false;
    }

    return false; // Enable for other cases
  }

  imgOnClick(img: any, $event: any, item: any) {
    this.updateitems(item.className, $event);
    item.options.forEach((element: any) => {
      element.selected = false;
    });
    img.selected = !img.selected;
    this.loadedComponent[item.func]($event, item.id);
  }

  datalabelToggleClick(item: any, $event: any) {
    item.options.forEach((m: any) => (m.selected = !m.selected));
    this.showDataLabel = !this.showDataLabel;
    $event.target.value = this.showDataLabel;
    this.updateitems(item.className, $event);
    this.loadedComponent[item.func]($event, item.id);
  }

  onInputChange(event: any) {
    this.widgetTitleText = event.target.value;
    if (this.widgetTitleText == '') {
      this.widgetTitleText = 'Trend Of Metric 2';
    }
  }

  goback() {
    this._configService.fromBackButton = true;
    this._configCustomService.fromBackButton = true;
    const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: true };
    this._configCustomService.recievedStatusDataOnBackButtonClick = dataToSend;
    this.routerObj.navigate(['/Snapshot/configuaration'], { state: { data: dataToSend } });
  }
  getCustomization(item: any): SafeHtml {
    let modifiedCustomization = item.customization.toString();
    if (modifiedCustomization.includes('#')) {
      modifiedCustomization = modifiedCustomization.replace(
        /#/,
        `<sup style="color:red !important;font-size:0.7em !important;">(#)</sup>`
      );
    }
    if (modifiedCustomization.includes('*')) {
      modifiedCustomization = modifiedCustomization.replace(
        /\*/g,
        '<sup style="color:red !important;font-size:0.7em !important;">(*)</sup>'
      );
    }
    // Check if 'Grouping' is present in the class name
    if (item.className.includes('Grouping')) {
      // Add indentation if not already present
      if (
        !modifiedCustomization.startsWith('<span style="margin-left: 2em;">')
      ) {
        // modifiedCustomization = `<span style="margin-left: 2em;">${modifiedCustomization}</span>`;
      }
    }
    return this.sanitizer.bypassSecurityTrustHtml(modifiedCustomization);
  }

  showDropDown = false;
  checkedList: any = [];
  // getSelectedValue(status:Boolean,value:String,select:any){
  //   if(status){
  //     this.checkedList.push(value);
  //   }else{
  //       var index = this.checkedList.indexOf(value);
  //       this.checkedList.splice(index,1);
  //   }
  // }
  metric: any = [];
  searchmetric: any = "";
  getSelectedValue(
    option: any,
    value: string,
    item: any,
    lev1: any = []
  ): void {
    if (item.select === 1) {
      option.checked = option.checked == null ? true : !option.checked;
      option.selectOrder = 1;
      // If select === 1, treat the checkbox as a radio button
      if (option.checked) {
        // Uncheck previously selected items
        item.checkedList = [{ option: value, selectOrder: option.selectOrder,typeofmetric:lev1.option }];
        // item.options.forEach((m: any) => {
        //   if (m != option) {
        //     m.checked = false;
        //     m.selectOrder = 0;
        //   }
        // });

        item.options.forEach((m: any) => {
          m.Level2.forEach((lev2:any) => {
            if (lev2 != option) {
              lev2.checked = false;
              lev2.selectOrder = 0;
            }
          })
        });
      } else {
        // If the radio button is unchecked, remove it from the checkedList
        item.checkedList = [];
      }
      let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
      if (existingmetric) {
        existingmetric.metric_value = item.checkedList;
      }
      else {
        this.metric.push({
          metric_option: item.customization,
          metric_value: item.checkedList,
          metric_group: ""
        })
      }
    }
    else if (item.select === 2) {
      //const maxSelectOrder = item.options.reduce((max: any, item: any) => (item.selectOrder > max ? item.selectOrder : max), 0);
      let metrics = item.options.filter((m:any) => m.option != "METRIC GROUP");
      let maxSelectOrder = 0;
      metrics.forEach((m:any)=>{
        maxSelectOrder = Math.max(m.Level2.reduce((max: any, item: any) => (item.selectOrder > max ? item.selectOrder : max), 0), maxSelectOrder);
      })

      // For multiple select checkboxes
      // option.checked = option.checked == null ? true : !option.checked;
      // if (option.checked) {
      //   // If checkbox is checked, add value to checkedList
      //   option.selectOrder = maxSelectOrder + 1;
      //   item.checkedList.push({ option: value, selectOrder: option.selectOrder });
      // } else {
      //   // If checkbox is unchecked, remove value from checkedList
      //   item.options.forEach((i: any) => {
      //     if (i.selectOrder > option.selectOrder) {
      //       i.selectOrder -= 1;
      //     }
      //   })
      //   option.selectOrder = 0;
      //   let v = item.checkedList.find((i: any) => i.option == value);
      //   let index = -1;
      //   if (v) { index = item.checkedList.indexOf(v); }
      //   if (index !== -1) {
      //     item.checkedList.splice(index, 1);
      //   }
      // }

      option.isSelected = option.isSelected == null ? true : !option.isSelected;
      lev1.Level2.forEach((l2: any) => {
      if (l2 == option) {
          if (option.isSelected) {
            option.selectOrder = maxSelectOrder + 1;
            item.checkedList.push({ option: value, selectOrder: option.selectOrder,typeofmetric:lev1.option });
          }
          else {
            // lev1.Level2.forEach((i: any) => {
            //   if (i.selectOrder > option.selectOrder) {
            //     i.selectOrder -= 1;
            //   }
            // })

            item.options.forEach((it:any) => {
              if(it.option != "METRIC GROUP"){
                it.Level2.forEach((lev2:any) => {
                  if(lev2.selectOrder > option.selectOrder) {
                    item.checkedList.forEach( (i:any) => {
                      if(i.option == lev2.option){
                        i.selectOrder -= 1;       
                      }
                    })
                    lev2.selectOrder -= 1;
                  }
                })
              }
            })

            option.selectOrder = 0;
            let v = item.checkedList.find((i: any) => i.option == value);
            let index = -1;
            if (v) { index = item.checkedList.indexOf(v); }
            if (index !== -1) {
              item.checkedList.splice(index, 1);
            }
          }
        }
      })
      
      let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
      if (existingmetric) {
        existingmetric.metric_value = item.checkedList;
      }
      else {
        this.metric.push({
          metric_option: item.customization,
          metric_value: item.checkedList,
          metric_group: ""
        })
      }
    }
    else if (item.select === 3) {
      // For radio buttons
      if (lev1.option == "METRIC GROUP") {
        lev1.Level2.forEach((l2: any) => {
          if (l2 == option) {
            l2.isSelected = true;
            l2.selectOrder = 1;
          }
          else {
            l2.isSelected = false;
            l2.selectOrder = 0;
          }
        });
        item.checkedList = [{ option: value, selectOrder: option.selectOrder,type:lev1.option }];
        item.options.forEach((i: any) => {
          if (i != lev1) {
            i.Level2.forEach((ii: any) => {
              ii.isSelected = false;
              ii.selectOrder = 0;
            })
          }
        })
        let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
        if (existingmetric) {
          existingmetric.metric_value = [];
          // item.checkedList = [];
          existingmetric.metric_group = value;
        }
        else {
          this.metric.push({
            metric_option: item.customization,
            metric_value: [],
            metric_group: value
          })
        }
      }
      if (lev1.option == "METRICS" || lev1.option == "CUSTOM METRICS") {

        let metrics = item.options.filter((m:any) => m.option != "METRIC GROUP");
        let maxSelectOrder = 0;
        metrics.forEach((m:any)=>{
          maxSelectOrder = Math.max(m.Level2.reduce((max: any, item: any) => (item.selectOrder > max ? item.selectOrder : max), 0), maxSelectOrder);
        })
        //const maxSelectOrder = lev1.Level2.reduce((max: any, item: any) => (item.selectOrder > max ? item.selectOrder : max), 0);
        

        // if (maxSelectOrder == 0) {
        //   item.checkedList = [];
        // }
        if(maxSelectOrder == 0){
          item.checkboxlist = [];
        }

        // item.options.forEach((i: any) => {
        //   if (i != lev1) {
        //     i.Level2.forEach((ii: any) => {
        //       ii.isSelected = false;
        //     })
        //   }
        // });

        let removeMetrics : any[] = [];
        item.options.forEach((i: any) => {
          if (i.option == "METRIC GROUP") {
            i.Level2.forEach((ii: any) => {
              if(ii.isSelected){
                removeMetrics.push({
                  option: ii.option,
                  selectOrder : ii.selectOrder,
                })
              }
              ii.isSelected = false;
            })
          }
        });
        option.isSelected = option.isSelected == null ? true : !option.isSelected;
        lev1.Level2.forEach((l2: any) => {
          if (l2 == option) {
            if (option.isSelected) {
              option.selectOrder = maxSelectOrder + 1;
              item.checkedList.push({ option: value, selectOrder: option.selectOrder,typeofmetric:lev1.option });
            }
            else {

              item.options.forEach((it:any) => {
                if(it.option != "METRIC GROUP"){
                  it.Level2.forEach((lev2:any) => {
                    if(lev2.selectOrder > option.selectOrder) {

                      item.checkedList.forEach( (i:any) => {
                        if(i.option == lev2.option){
                          i.selectOrder -= 1;       
                        }
                      })
                      lev2.selectOrder -= 1;
                    }
                  })
                }
              })
              // lev1.Level2.forEach((i: any) => {
              //   if (i.selectOrder > option.selectOrder) {
              //     i.selectOrder -= 1;
              //   }
              // })
              option.selectOrder = 0;
              let v = item.checkedList.find((i: any) => i.option == value);
              let index = -1;
              if (v) { index = item.checkedList.indexOf(v); }
              if (index !== -1) {
                item.checkedList.splice(index, 1);
              }
            }
          }
        })

        item.checkedList = item.checkedList.filter( (it:any) => !removeMetrics.some((remove:any) => 
          remove.option === it.option && remove.selectOrder === it.selectOrder
        ));

        let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
        if (existingmetric) {
          existingmetric.metric_value = item.checkedList;
        }
        else {
          this.metric.push({
            metric_option: item.customization,
            metric_value: item.checkedList,
            metric_group: ""
          })
        }
      }
    }
  }
  widgetDetails: any;
  fromSave = false;
  checkbox: any = {};
  previousnumberofFunnelLevels = 4;
  numberofFunnelLevels = 4;
  showConfirmationPopUp: boolean = false;
  callCustomization($event: any, item: any) {
    if (item.customization !== "Number of Levels : ") {
      this.loadedComponent[item.func]($event, item.id);
    }
    else {
      this.numberofFunnelLevels = Number($event.target.value);
      this.items.forEach((i: any) => {
        if (i.id == "Number of Levels") {
          i.selectedValue = this.previousnumberofFunnelLevels;
        }
      });
      this._cdref.detectChanges();
      this.showConfirmationPopUp = true;
      this.errorheaderTitle = "Confirmation";
      this.popUpMessage = "Changing the funnel level would reset the metrics. Are you sure you want to proceed?"
    }
  }

  onConfirmationClick($event: any) {
    this.previousnumberofFunnelLevels = this.numberofFunnelLevels;
    this.showConfirmationPopUp = false;
    this.items.forEach((i: any) => {
      if (i.id == "Number of Levels") {
        i.selectedValue = this.previousnumberofFunnelLevels;
      }
      if (i.id == "Metric") {
        i.options.forEach((o: any) => {
          o.isSelected = false;
          o.checked = false;
          o.selectOrder = 0;
        });
        i.checkedList = [];
        this.metric = [];
        i.maxMetricLimit = this.numberofFunnelLevels;
        this.loadedComponent[i.func](this.numberofFunnelLevels, "Number of Levels");
      }
    });
  }

  checkBoxesClicked(event: any, item: any) {
    item.checked = event.target.checked;
    this.checkbox[item.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = event.target.checked;
  }

  OutsidecheckBoxesClicked($event: any, item: any) {
    item.checked = $event.target.checked;
    //this.checkbox[item.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = event.target.checked;
    this.updateitems(item.className, $event);
    this.loadedComponent[item.func]($event, item.id);
  }

  restrictInput(event: KeyboardEvent,$event1: any,item: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Allow only numbers (0-9)
    }
  }

  validateNumber(event: any, item: any, inputElement: any) {
    let value = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
    let numberValue = Number(value);
  
    if (numberValue < 0 || numberValue > 100 || isNaN(numberValue)) {
      numberValue = Math.min(Math.max(numberValue, 1), 100);
    } else {
      // Update textarea value
      event.value = numberValue; 
      this.loadedComponent[item.func](event, item.id);
    }
    event.target.value = numberValue;
    if(value==""){
       if(item.id == 'Start Value'){
         event.value = 0;
         event.target.value = "";
       }
       else if(item.id == 'End Value'){
        event.value = 100;
        event.target.value = "";
      }
      else if(item.id == 'Target Value'){
        event.value = 0;
        event.target.value = "";
      }
       this.loadedComponent[item.func](event, item.id);
    }
  }

  additonalfeatureStatus() {
    const trueEntries = Object.entries(this.checkbox).filter(([key, value]) => value === true);
    const trueCount = trueEntries.length;

    switch (trueCount) {
      case 0:

        return "Select";

      case 1:
        const [keyOfSingleTrue] = trueEntries[0]; // Extract the key from the single true entry
        return keyOfSingleTrue;
      // You can use `keyOfSingleTrue` here as needed

      default:
        return "Multiple";
    }

  }

  @Output() customSaveData = new EventEmitter<any>();
  saveCurrentWidget() {
    this.metric.forEach((m: any) => {
      if (m.metric_value.length > 0) {
        m.metric_group = ""
      }
    })
    this.showErrorPopUp = false;
    const storedProperties = localStorage.getItem('properties');
    if (storedProperties) {
      let properties = JSON.parse(storedProperties);
      let widgetNames = []; let widgetNames1 = [];
      // if (localStorage.getItem('TotalwidgetDetailss') != "" && localStorage.getItem('TotalwidgetDetailss') != null && localStorage.getItem('TotalwidgetDetailss') != undefined) {
      //   this._configService.WidgetLibSaveDataObject = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || "");
      if (this.metric.length < this.countOfMetricsTobeConfigured) {
        this.showErrorPopUp = true;
        this.popUpMessage = "Please select METRIC.";
        this.errorheaderTitle = "Error";
        return;
      }
      else {
        this.metric.forEach((m: any) => {
          if (m.metric_group == "" && m.metric_value.length <= 0) {
            this.showErrorPopUp = true;
            this.popUpMessage = "Please select METRIC.";
            this.errorheaderTitle = "Error";
            return;
          }
        })
        if(this.chartTitle == "spider/radar"){
          let metricount=0;
          if(this.metric[0].metric_value.length>0){
              this.metric[0].metric_value.forEach((m: any) => {
                  if(m.typeofmetric!=undefined){
                    metricount=metricount+1;
                  }
              })
          }
          if(this.metric[0].metric_group == "" && metricount<3){
            this.showErrorPopUp = true;
            this.popUpMessage = "Please select at least 3 metrics or one metric group";
            this.errorheaderTitle = "Error";
            return;
          }
        }
      }


      // Prepare customization list
      const customization = Object.keys(properties).map((key) => ({
        key,
        value:properties[key]==null? properties[key]:properties[key].toString(),
      }));

      //adding new properties which doesnt exist in respective chart components 
      properties.infoText = this.customWidgetIcontext;
      properties.maxMetricLimit=this.maxMetricLimit;
      const filteredItems = this._configCustomService.ChartPropertiesOptionSelection.filter(
        (item:any) =>
          item.Chart.trim().toLowerCase() === this.chartTitle.trim().toLowerCase() &&
        item.SnapshotType.replace(/\s+/g, '').toLowerCase()=== this._configCustomService.selectedSnapshotType.name.replace(/\s+/g, '').toLowerCase()
      );
      if(filteredItems){
      properties.trendlineOutputView=filteredItems[0]?.TrendLine;
      }
      properties = { ...properties, ...this.checkbox };
      if (properties.infoText != "") {
        this.checkbox["InfoText"] = properties.infoText;
      }
      properties.additionalGroup = this.checkbox;
      // if(this.chartproperties?.showLegend!=undefined && this.chartproperties?.showLegend!=null)
      //      properties.additionalGroup.showLegend=this.chartproperties?.showLegend;
      if (!this.isEditWidget) {

        let CurrwidgetDetails = {
          "widget_name": this.widgetTitleText,
          "widgetchart_name": this.chartTitle,
          "widgetParentChartType": this.bucketName,
          "customizationProperties": JSON.stringify(properties),
          "previewChartPostion": 0,
          // "metric": this.metric,
          "metric": this.metric.map((item: any) => ({
            ...item,
            metric_value: [JSON.stringify(item.metric_value)]
          }))
        };
        this._configCustomService.selectedSnapshotName = this.clientDetails.clientDetails.study;
        let objtoSave = {
          IsclientonSubmit: false,
          snapshotType: [{
            snapshotType_name: this._configCustomService.selectedSnapshotType.name,
            section: [{
              section_name: this._configCustomService.selectedSection,
              subsection: [{
                subsection_name: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
                widget_detail: [CurrwidgetDetails],
                page_details: []
              }]
            }]
          }],
          client_name: this._configService.clientName,
          snapshot_name: this.clientDetails.clientDetails.study
        }
        if (this._configCustomService.widgetSaveObjectCustom.length == 0) {
          this._configCustomService.widgetSaveObjectCustom.push(objtoSave);
        }
        else {
          let snaphottypes = this._configCustomService.widgetSaveObjectCustom.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
          if (snaphottypes) {
            let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
            if (snapshotType) {
              let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
              if (section) {
                let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
                if (subsection) {
                  widgetNames = subsection.widget_detail.map((widget: any) => widget.widget_name);
                  if (this.widgetTitleText == '' || this.widgetTitleText == null || widgetNames.includes(this.widgetTitleText) && this.chartTitle.toLowerCase() != "line chart") {
                    this.showErrorPopUp = true;
                    this.popUpMessage = "Widget name is empty or already exists. Please enter a valid widget name.";
                    this.errorheaderTitle = "Error";
                  }
                  else if (this.chartTitle.toLowerCase() != "line chart") {
                    subsection.widget_detail.push(CurrwidgetDetails);
                  }
                  //specifically for trendline chart 
                  else {
                    let widgetdetails = subsection.widget_detail.find((widget: any) => widget.widget_name == this.widgetTitleText);
                    if (widgetdetails) {
                      widgetdetails.widget_name = this.widgetTitleText;
                      widgetdetails.metric = this.metric;
                      widgetdetails.customizationProperties = JSON.stringify(properties);
                    }
                    else {
                      subsection.widget_detail.push(CurrwidgetDetails);

                    }
                  }
                }
                else {
                  section.subsection.push({
                    subsection_name: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
                    widget_detail: [CurrwidgetDetails],
                    page_details: []
                  });
                }
              }
              else {
                snapshotType.section.push({
                  section_name: this._configCustomService.selectedSection,
                  subsection: [{
                    subsection_name: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
                    widget_detail: [CurrwidgetDetails],
                    page_details: []
                  }]
                })
              }
            }
            else {
              snaphottypes.snapshotType.push({
                snapshotType_name: this._configCustomService.selectedSnapshotType.name,
                section: [{
                  section_name: this._configCustomService.selectedSection,
                  subsection: [{
                    subsection_name: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
                    widget_detail: [CurrwidgetDetails],
                    page_details: []
                  }]
                }]
              })
            }
          }
          else {
            this._configCustomService.widgetSaveObjectCustom.push(objtoSave);
          }
        }
      }
      else {
        let snaphottypes = this._configCustomService.widgetSaveObjectCustom.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
        if (snaphottypes) {
          let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
          if (snapshotType) {
            let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
            if (section) {
              let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
              if (subsection) {
                widgetNames = subsection.widget_detail.map((widget: any) => widget.widget_name).filter((w: any) => w != this.userselectedchartdata?.widgetEditSelection?.widget_name);
                if (this.widgetTitleText == '' || this.widgetTitleText == null || widgetNames.includes(this.widgetTitleText)) {
                  this.showErrorPopUp = true;
                  this.popUpMessage = "Widget name is empty or already exists. Please enter a valid widget name.";
                  this.errorheaderTitle = "Error";
                }
                else {
                  let widgetdetails = subsection.widget_detail.find((widget: any) => widget.widget_name == this.userselectedchartdata?.widgetEditSelection?.widget_name);
                  if (widgetdetails) {
                    widgetdetails.widget_name = this.widgetTitleText;
                    widgetdetails.metric = this.metric.map((item: any) => ({
                      ...item,
                      metric_value: [JSON.stringify(item.metric_value)]
                    }));
                    widgetdetails.customizationProperties = JSON.stringify(properties);
                  }
                }
              }

            }

          }
        }
      }

      if (!this.showErrorPopUp) {
        this._configCustomService.disablePreviewOnCustomizationSave = 1;//to disable preview
        this.showErrorPopUp = true;
        this.popUpMessage = "Saved Successfully.";
        this.errorheaderTitle = "Info";
        this.errorheaderTitle = "Info";
        this.fromSave = true;
        // this.goback();

        // this._configCustomService.saveCustomSnapshotWidgetLibrary(this._configCustomService.widgetSaveObjectCustom[0]).subscribe(
        //   (response: any) => {
        //     // response = JSON.parse(response.result);
        //     if (response.Data == 'Document updated successfully') {
        //       // Handle success here
        //       this.showErrorPopUp = true;
        //       this.popUpMessage = "Saved Successfully.";
        //       this.errorheaderTitle = "Info";
        //       this.fromSave = true;

        //     }
        //     else if (response.Data == 'Document inserted successfully') {
        //       this.showErrorPopUp = true;
        //       this.popUpMessage = "Saved Successfully.";
        //       this.errorheaderTitle = "Info";
        //       this.fromSave = true;

        //     }
        //     else {
        //       // Handle any non-200 response codes
        //       this.showErrorPopUp = true;
        //       this.popUpMessage = "Some Error Occured";
        //       this.errorheaderTitle = "Info";
        //       this.fromSave = false;
        //     }
        //   }
        // );
      }


    }
  }

  onCloseIconClick(closePopUp: string): void {
    if (closePopUp == 'false') {
      this.showErrorPopUp = false;
      if (this.fromSave) {
        this.goback();
      }
    }
    if (this.showConfirmationPopUp) {

      this.items.forEach((i: any) => {
        if (i.id === "Number of Levels") {
          i.selectedValue = this.previousnumberofFunnelLevels;
        }
      });
      let items = this.items;
      this.items = [];
      this._cdref.detectChanges();

      setTimeout(() => {
        this.items = items;
      }, 0)
      this._cdref.detectChanges();
    }
    this.showConfirmationPopUp = false;
  }

  togglemetriclev1Dropdown(options: any, lev1: any) {
    this.searchmetric = "";
    options.forEach((i: any) => {
      if (i == lev1) {
        lev1.isDropdownOpen = !lev1.isDropdownOpen;
      }
      else {
        i.isDropdownOpen = false;
      }
    })
    lev1.Level2 = lev1.Level2.sort((a: any, b: any) => a.index - b.index);
    lev1.Level2 = lev1.Level2.sort((a: any, b: any) => {
      const selectOrderA = a.selectOrder ?? 0;
      const selectOrderB = b.selectOrder ?? 0;

      // If both have the same non-zero selectOrder, sort normally
      if (selectOrderA !== 0 && selectOrderB !== 0) {
        return selectOrderA - selectOrderB;
      }

      // If one is zero, prioritize the other
      if (selectOrderA === 0 && selectOrderB !== 0) {
        return 1; // Move A (with zero) after B
      }
      if (selectOrderA !== 0 && selectOrderB === 0) {
        return -1; // Move B (with zero) after A
      }

      // If both are zero, they remain in the same relative order
      return 0;
    });
  }

  toggleMetricDropdown(item: any, onmouseLeave: boolean) {
    this.searchmetric = "";
    item.options = item.options.sort((a: any, b: any) => a.index - b.index);
    item.options = item.options.sort((a: any, b: any) => {
      const selectOrderA = a.selectOrder ?? 0;
      const selectOrderB = b.selectOrder ?? 0;

      // If both have the same non-zero selectOrder, sort normally
      if (selectOrderA !== 0 && selectOrderB !== 0) {
        return selectOrderA - selectOrderB;
      }

      // If one is zero, prioritize the other
      if (selectOrderA === 0 && selectOrderB !== 0) {
        return 1; // Move A (with zero) after B
      }
      if (selectOrderA !== 0 && selectOrderB === 0) {
        return -1; // Move B (with zero) after A
      }

      // If both are zero, they remain in the same relative order
      return 0;
    });
    this._cdref.detectChanges();
    item.showDropdown = onmouseLeave ? false : !item.showDropdown;
    if (item.select == 3) {
      item.options.forEach((i: any) => {
        i.isDropdownOpen = false;
      })
    }
  }

  isAdditionalDropdownOpen: boolean = false;
  toggleAdditionaldropdown() {
    this.isAdditionalDropdownOpen = !this.isAdditionalDropdownOpen;
  }

  // resetSelections(item: any, options: any, lev1: any = []) {
  //   if (item.select != 3) {
  //     item.options = item.options.sort((a: any, b: any) => a.index - b.index);
  //     item.checkedList = [];
  //     options.forEach((o: any) => {
  //       o.checked = false;
  //       o.selectOrder = 0;
  //     })
  //   }
  //   else {
  //     lev1.Level2 = lev1.Level2.sort((a: any, b: any) => a.index - b.index);
  //     item.checkedList = [];
  //     lev1.Level2.forEach((o: any) => {
  //       o.isSelected = false;
  //       o.selectOrder = 0;
  //     })
  //   }
  //   this.metric = this.metric.filter((m: any) => m.metric_option !== item.customization);
  // }

  resetSelections(item: any, options: any, lev1: any = []) {

    let removeMetrics : any[] = [];
    

    
    
    if (item.select == 1) {
      item.options = item.options.sort((a: any, b: any) => a.index - b.index);
      options.forEach((o: any) => {
        o.checked = false;
        o.selectOrder = 0;
      })
      lev1.Level2.forEach( (lev2:any) => {
        if(lev2.checked){
          removeMetrics.push({
            option : lev2.option, 
            selectOrder : lev2.selectOrder
            
          })
        }
      })
    }
    else {
      if(lev1.option == "METRICS" || lev1.option == "CUSTOM METRICS"){

        lev1.Level2.forEach( (lev2:any) => {
          if(lev2.isSelected){
            removeMetrics.push({
              option : lev2.option, 
              selectOrder : lev2.selectOrder
              
            })
          }
        })
        let arrayofSelectedOrder: any[] = [];
        item.options.forEach((it:any)=>{
          if(it.option == lev1.option){
            it.Level2.forEach((lev2:any) => {
              if(lev2.isSelected){
                arrayofSelectedOrder.push(lev2.selectOrder);
                lev2.selectOrder = 0;
                lev2.isSelected = false;
                
              }
            })
          }
        })

        item.options.forEach((it:any)=>{
          if(it.option != lev1 && it.option != "METRIC GROUP"){
            it.Level2.forEach((lev2:any) => {
              if(lev2.isSelected){
                if(lev2.selectOrder){
                  let count = 0;
                  for( let i = 0 ; i <arrayofSelectedOrder.length ; i++ ){
                    if(lev2.selectOrder> arrayofSelectedOrder[i] ){
                      count++;
                    }
                  }
                  lev2.selectOrder = lev2.selectOrder-count;
                }
              }
            })
          }
        })
      }else{
        item.options.forEach((it: any) => {
          if(it.option == lev1){
            it.Level2.forEach((lev2:any)=>{
                lev2.checked = false;
                lev2.selectOrder = 0;
            })
          }
          
        })
      }
      
      // lev1.Level2 = lev1.Level2.sort((a: any, b: any) => a.index - b.index);
      // item.checkedList = [];
      // lev1.Level2.forEach((o: any) => {
      //   o.isSelected = false;
      //   o.selectOrder = 0;
      // })
    }

    item.checkedList = item.checkedList.filter( (it:any) => !removeMetrics.some((remove:any) => 
      remove.option === it.option && remove.selectOrder === it.selectOrder
    ));
    this.metric.forEach( (metric:any) => {
      if( metric.metric_option == item.customization){
        metric.metric_value = metric.metric_value.filter((metricValue: any) => item.checkedList.some((remove : any) => 
          remove.option === metricValue.option && remove.selectOrder === metricValue.selectOrder
        ))
      }
    });
    //this.metric = this.metric.filter((m: any) => m.metric_option !== item.customization);

  }

}


function subscribe(arg0: (data: any) => void) {
  throw new Error('Function not implemented.');
}

